import React from "react";
import PropTypes from 'prop-types';
import { faRedo, faToggleOff, faToggleOn } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Component } from 'react';
import { Button, Col, Modal, Row, Table } from 'react-bootstrap';
import { Trans, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import apiService from '../../services/apiKeyService';
import { modalActionCreator } from '../../store/actions/modalActions';
import { ApiKeyButton, getApiKeyDisplayName, isLs360ApiKeyType } from './ApiKeyButton';
import { apiKeyTypes } from '../../utilities/constants'

import '../../styles/spm.css';

class ApiKeyList extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showScanItemsModal: false,
            returnError: '',
            showResetPasswordModal: false,
            editApiKey: {},
            pendingApiKey: null,
        };


        this.resetApiKeyPassword = this.resetApiKeyPassword.bind(this);
        this.confirmSetApiKeyEnabled = this.confirmSetApiKeyEnabled.bind(this);
        this.hideSetApiKeyEnabledModal = this.hideSetApiKeyEnabledModal.bind(this);
        this.setApiKeyEnabled = this.setApiKeyEnabled.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    closeModal(event) {
        this.props.hideModal();
    }

    confirmSetApiKeyEnabled(apiKey) {
        this.setState({ pendingApiKey: apiKey });
    }

    hideSetApiKeyEnabledModal() {
        this.setState({ pendingApiKey: null });
    }

    setApiKeyEnabled() {
        const t = this.props.t;
        const apiKey = this.state.pendingApiKey;
        const enabled = !apiKey.isEnabled;

        apiService.setApiKeyEnabled(apiKey.id, enabled)
            .then(response => {
                if (response.data.success) {
                    // Enabling one key suspends the other, so every key the server changed is returned.
                    const changed = response.data.payload || [];
                    const existing = this.props.organization.apiKeys.map(
                        key => changed.find(changedKey => changedKey.id === key.id) || key);
                    this.props.modifyState("apiKeys", existing);
                }
            })
            .catch(error => {
                // A rejected ResultDto comes back as a 422, so the message lives on the error response.
                const message = error.response && error.response.data && error.response.data.message;
                window.alert(message || t("Failed to update the API key."));
            })
            .finally(() => {
                this.hideSetApiKeyEnabledModal();
            });
    }

    resetApiKeyPassword(apiKeyId) {
        //const apiKeyId = this.state.editApiKey.id;
        apiService.resetApiKey(apiKeyId)
            .then(response => {
                if (response.data.success) {
                    var result = response.data.payload;
                    var current = this.props.organization.apiKeys.filter(key => key.id === result.id)[0];
                    result.apiKeyType = current.apiKeyType;
                    var existing = this.props.organization.apiKeys.filter(x => x.id !== result.id);
                    existing.push(result);
                    this.props.modifyState("apiKeys", existing);
                    this.props.hideModal();
                }
            });
    }



    render() {
        const t = this.props.t;
        const pendingApiKey = this.state.pendingApiKey;
        const disablingPendingKey = pendingApiKey !== null && pendingApiKey.isEnabled;
        return (
          <div>
            <Modal bsSize="small" show={pendingApiKey !== null}>
              <Modal.Header>
                <Modal.Title>
                  {disablingPendingKey ? (
                    <Trans>Confirm Disable Api Key</Trans>
                  ) : (
                    <Trans>Confirm Enable Api Key</Trans>
                  )}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {disablingPendingKey
                  ? t("Disabling the {{ apiKeyType }} will stop messages from being sent for this organization.",
                      { apiKeyType: getApiKeyDisplayName(pendingApiKey.apiKeyType) })
                  : t("Enabling the {{ apiKeyType }} will disable all other LS360 Api client keys for this organization.",
                      { apiKeyType: pendingApiKey ? getApiKeyDisplayName(pendingApiKey.apiKeyType) : "" })}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  onClick={this.hideSetApiKeyEnabledModal}
                  variant="light"
                  type="button"
                >
                  <Trans>Cancel</Trans>
                </Button>
                <Button
                  onClick={this.setApiKeyEnabled}
                  variant={disablingPendingKey ? "warning" : "success"}
                  type="button"
                >
                  {disablingPendingKey ? (
                    <Trans>Disable</Trans>
                  ) : (
                    <Trans>Enable</Trans>
                  )}
                </Button>
              </Modal.Footer>
            </Modal>
            <Modal bsSize="small" show={this.state.showResetPasswordModal}>
              <Modal.Header>
                <Modal.Title>
                  <Trans>Confirm Password Reset</Trans>
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <Trans>Are you sure you want to reset the api key:</Trans>{" "}
                {this.state.editApiKey.clientName}?
              </Modal.Body>
              <Modal.Footer>
                <Button
                  onClick={this.hideResetPasswordModal}
                  variant="light"
                  type="button"
                >
                  <Trans>Cancel</Trans>
                </Button>
                <Button
                  onClick={this.resetApiKeyPassword}
                  variant="warning"
                  type="button"
                >
                  <Trans>Reset</Trans>
                </Button>
              </Modal.Footer>
            </Modal>
            <Row>
              <Col>
                <Table striped hover responsive>
                  <thead>
                    <tr>
                      <th className="table-fit">
                        <Trans>Client Name</Trans>
                      </th>
                      <th className="table-fit">
                        <Trans>Client Secret</Trans>
                      </th>
                      <th>
                        <Trans>Client Type</Trans>
                      </th>
                      <th className="table-fit" />
                      <th className="table-fit">
                        <Trans>Status</Trans>
                      </th>
                      <th className="table-fit">
                        <ApiKeyButton
                          showModal={this.props.showModal}
                          closeModal={this.closeModal}
                          organization={this.props.organization}
                          onSaved={(result)=> {
                              let existing = this.props.organization.apiKeys.filter((x) => x.id !== result.id);
                              existing.push(result);
                              this.props.modifyState("apiKeys", existing);

                              if (result.apiKeyType === apiKeyTypes.acmeware) {
                                  var org = this.props.organization;
                                  org.hasMeditechApiKey = true;
                                  this.props.modifyState("organization", org);
                              }
                          }}
                        />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.props.apiKeys.map((item, i) => {
                      return (
                        // put mapper here @foreach (var apiKey in Model.ApiKeys)
                        <tr key={item.id}>
                          <td className="table-fit">{item.clientName}</td>
                          <td className="table-fit">{item.clientSecret}</td>
                          <td>{getApiKeyDisplayName(item.apiKeyType)}</td>
                          <td className="table-fit">
                            {item.apiKeyType &&
                              isLs360ApiKeyType(item.apiKeyType) && (
                                <FontAwesomeIcon
                                  icon={
                                    item.isEnabled ? faToggleOn : faToggleOff
                                  }
                                  className={`gi-1-5x show-hand ${
                                    item.isEnabled
                                      ? "text-success"
                                      : "text-secondary"
                                  }`}
                                  title={
                                    item.isEnabled
                                      ? t("Disable Api Key")
                                      : t("Enable Api Key")
                                  }
                                  onClick={() =>
                                    this.confirmSetApiKeyEnabled(item)
                                  }
                                />
                              )}
                          </td>
                          <td className="table-fit">{item.status}</td>
                          <td className="table-fit">
                            <FontAwesomeIcon
                              icon={faRedo}
                              className="gi-1-5x text-warning show-hand"
                              title={t("Reset Client Secret")}
                              onClick={() =>
                                this.props.showModal(
                                  {
                                    open: true,
                                    title: t("Confirm Client Secret Reset."),
                                    message:
                                      t(
                                        "Are you sure you want to reset the client secret for the {{ apiKeyType }}?",
                                        { apiKeyType: getApiKeyDisplayName(item.apiKeyType) }
                                      ) +
                                      "\n\n" +
                                      t("Client Name: {{clientName}}", {
                                        clientName: item.clientName,
                                      }),
                                    confirm: () =>
                                      this.resetApiKeyPassword(item.id),
                                    confirmVariant: "warning",
                                    confirmText: t("Reset"),
                                    cancel: this.props.hideModal,
                                    cancelVariant: "light",
                                  },
                                  "confirm"
                                )
                              }
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </Col>
            </Row>
          </div>
        );
    }
}

const apiKeyShape = PropTypes.shape({
    id: PropTypes.number.isRequired,
    clientName: PropTypes.string,
    clientSecret: PropTypes.string,
    apiKeyType: PropTypes.string,
    status: PropTypes.string,
    isEnabled: PropTypes.bool,
});

ApiKeyList.propTypes = {
    apiKeys: PropTypes.arrayOf(apiKeyShape).isRequired,
    organization: PropTypes.shape({
        apiKeys: PropTypes.arrayOf(apiKeyShape).isRequired,
        hasMeditechApiKey: PropTypes.bool,
    }).isRequired,
    modifyState: PropTypes.func.isRequired,
    showModal: PropTypes.func.isRequired,
    hideModal: PropTypes.func.isRequired,
    t: PropTypes.func.isRequired,
};

export default withTranslation()(connect(null, dispatch => bindActionCreators(modalActionCreator, dispatch))(ApiKeyList));
